/**
 * Returns true when a product variant should be shown for the given selected price.
 *
 * Variants with an empty/missing priceIds array are "legacy" variants that apply
 * to all prices. When priceIds is non-empty the variant only appears when
 * selectedPriceId is one of the listed IDs.
 *
 * IMPORTANT: pass the EFFECTIVE selected price id (see
 * useCheckoutState.effectiveSelectedPriceId / useSelectedPrice), which resolves a
 * single-price product to its lone price. A null/undefined value therefore means a
 * multi-price product with no choice yet — a price-scoped variant stays hidden
 * until the buyer picks a price, since variants belong to a price.
 *
 * @param {object} variant - The product variant object.
 * @param {string | null | undefined} selectedPriceId - The buyer's effective selected price ID.
 * @returns {boolean}
 */
export default function checkIsVariantForPrice(variant, selectedPriceId) {
  const priceIds = variant?.priceIds;

  if (!priceIds || priceIds.length === 0) return true;

  if (selectedPriceId == null) return false;

  return priceIds.map(String).includes(String(selectedPriceId));
}
